'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Remove = require('./Remove');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Remove).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Remove/index.js
// module id = 1274
// module chunks = 1